import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { companyUserType, usersType } from '../../types';

const initialState: usersType = {
    users: [],
    is_adding_user: false,
    is_loading_users: false,
    is_updating_user: false,
};

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        getUsersSuccess: (state, action: PayloadAction<Array<companyUserType>>) => {
            return {
                ...state,
                users: action.payload,
            };
        },
        onLoadingUsers: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_users: action.payload
            };
        },
        onAddingUser: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_user: action.payload
            };
        },
        onUpdatingCompanyUser: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_user: action.payload,
            };
        },
    }
});

export const { getUsersSuccess, onAddingUser, onLoadingUsers, onUpdatingCompanyUser } = usersSlice.actions;

export default usersSlice.reducer;